import { Component, OnDestroy } from '@angular/core';
import { APIService } from 'src/app/services/APIService';
import { AuthService } from 'src/app/services/auth.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { ConstantsModule } from 'src/app/services/constants.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessagesService } from 'src/app/services/messages.service';
import { PopupComponent } from '../popup/popup.component';
import { RegistrationService } from 'src/app/services/registration.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent extends APIService implements OnDestroy {

  constructor(public localService: LocalUtilService,
      public authService: AuthService,
      public registrationService: RegistrationService,
      private modalService: NgbModal,
      private messageService: MessagesService,
      location: Location, 
      router: Router, translateService: TranslateService) { 
      console.log('LoginComponent()');
      super(localService, location, router, translateService);
  }

  username: string;
  password: string;
  private subscriptions: Subscription[] = [];
  
  doLogin() {
    
    let loginData = {
      username : this.username,
      passwd : this.password
    };
    
    const service = this.authService.login(loginData).subscribe(
      data => {
        console.log(data);          
        if (data.token != undefined) {
          this.localUtil.setAuthorizationFailed('false');
          this.localService.setAuthParams(data);      
          this.gotoLanding();
        } else {
          this.handleError(true);
        }
      },
      this.handleError(true)
    );
    this.subscriptions.push(service);
    return false;
  }

  gotoLanding() {
    
    this.router.navigate([this.localUtil.getDashboardPath()])
      .then(() => {
        window.location.reload();
      });

  }

  forgotPassword() {
    const modalRef = this.modalService.open(PopupComponent);
    modalRef.componentInstance.titolo = this.messageService.getLabelFromCode("FORGOT_PASSWORD_TITLE");
    modalRef.componentInstance.messaggio = this.messageService.getLabelFromCode("FORGOT_PASSWORD_REQUEST");
    modalRef.componentInstance.tipo = 'forgotPassword';
    const service = modalRef.componentInstance.passEntry.subscribe((receivedEntry:any) => {
      if (receivedEntry != undefined) {

        let email = receivedEntry.trim();

        const service = this.authService.rememberPwd(email).subscribe(
          data => {
            this.localUtil.showMessage("", ConstantsModule.INFO_TITLE, this.messageService.getLabelFromCode("FORGOT_PASSWORD_SUCCESS"), true);
          },
          this.handleError(true)
        );
        this.subscriptions.push(service);
      }
    });
    this.subscriptions.push(service);    

  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
                
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
  }

}
